import { useTranslation } from 'react-i18next';
import { Input } from '../../ui/input';

export interface ContentFiltersFieldsProps {
  categories: string;
  excludeTags: string;
  minImportance: number;
  onCategoriesChange: (v: string) => void;
  onExcludeTagsChange: (v: string) => void;
  onMinImportanceChange: (v: number) => void;
  /** hide minimum importance row (integrations that do not use it) */
  showMinImportance?: boolean;
  /** Inside an existing Card with its own title, omit section heading */
  variant?: 'standalone' | 'embedded';
  className?: string;
}

export function ContentFiltersFields({
  categories,
  excludeTags,
  minImportance,
  onCategoriesChange,
  onExcludeTagsChange,
  onMinImportanceChange,
  showMinImportance = true,
  variant = 'standalone',
  className = '',
}: ContentFiltersFieldsProps) {
  const { t } = useTranslation('integrations');

  return (
    <div className={`space-y-4 ${className}`}>
      {variant === 'standalone' && (
        <div>
          <h3 className="text-gray-900 font-medium mb-1">
            {t('bindingSections.contentFiltering.title')}
          </h3>
          <p className="text-gray-600 text-sm mb-2">
            {t('bindingSections.contentFiltering.description')}
          </p>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <label className="text-gray-600 text-xs font-medium">
            {t('bindingSections.contentFiltering.allowedCategories')}
          </label>
          <Input
            value={categories}
            onChange={(e) => onCategoriesChange(e.target.value)}
            placeholder={t(
              'bindingSections.contentFiltering.allowedCategoriesPlaceholder'
            )}
            className="bg-white border-gray-300 text-gray-900 text-sm"
          />
        </div>
        <div className="space-y-2">
          <label className="text-gray-600 text-xs font-medium">
            {t('bindingSections.contentFiltering.excludeTags')}
          </label>
          <Input
            value={excludeTags}
            onChange={(e) => onExcludeTagsChange(e.target.value)}
            placeholder={t('bindingSections.contentFiltering.excludeTagsPlaceholder')}
            className="bg-white border-gray-300 text-gray-900 text-sm"
          />
        </div>
        {showMinImportance && (
          <div className="space-y-2 md:col-span-2">
            <label className="text-gray-600 text-xs font-medium">
              {t('bindingSections.contentFiltering.minImportance')}
            </label>
            <Input
              type="number"
              min={1}
              max={10}
              value={minImportance}
              onChange={(e) =>
                onMinImportanceChange(parseInt(e.target.value, 10) || 1)
              }
              className="bg-white border-gray-300 text-gray-900 text-sm max-w-xs"
            />
            <p className="text-gray-500 text-xs">
              {t('bindingSections.contentFiltering.minImportanceHelp')}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
